import { useEffect, useState } from 'react';
import { Button } from 'antd';
import { ReloadOutlined, WifiOutlined } from '@ant-design/icons';
import './offline-gate.css';

function getOnline() {
  return typeof navigator !== 'undefined' && navigator.onLine;
}

function OfflineScreen() {
  return (
    <div className="offline-gate__overlay" role="alert" aria-live="assertive">
      <div className="offline-gate__inner">
        <WifiOutlined className="offline-gate__icon" aria-hidden />
        <h1 className="offline-gate__title">Отсутствует подключение к сети</h1>
        <p className="offline-gate__hint">проверьте соединение и обновите страницу</p>
        <Button
          type="primary"
          size="large"
          icon={<ReloadOutlined />}
          onClick={() => window.location.reload()}
        >
          Обновить
        </Button>
      </div>
    </div>
  );
}

export function OfflineGate({ children }) {
  const [online, setOnline] = useState(getOnline);

  useEffect(() => {
    const sync = () => setOnline(getOnline());
    window.addEventListener('online', sync);
    window.addEventListener('offline', sync);
    sync();
    return () => {
      window.removeEventListener('online', sync);
      window.removeEventListener('offline', sync);
    };
  }, []);

  useEffect(() => {
    if (!online) {
      const prevHtml = document.documentElement.style.overflow;
      const prevBody = document.body.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      return () => {
        document.documentElement.style.overflow = prevHtml;
        document.body.style.overflow = prevBody;
      };
    }
  }, [online]);

  return (
    <>
      {children}
      {!online && <OfflineScreen />}
    </>
  );
}
